/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Location, radius, and zone types for finding nearby marketplace zones. */
export type MarketplaceNearbyZonesInput = {
  /** Latitude of the search point in decimal degrees. */
  latitude: Types.Scalars['Latitude']['input'];
  /** Maximum nearby zones to return, up to 100; defaults to 20. */
  limit?: Types.Scalars['SafeInt']['input'] | null | undefined;
  /** Longitude of the search point in decimal degrees. */
  longitude: Types.Scalars['Longitude']['input'];
  /** Search radius around the point, from 1 to 160,000 meters; defaults to 16,000. */
  searchDistanceMeters?: Types.Scalars['SafeInt']['input'] | null | undefined;
  /** Zone types to include; defaults to neighborhoods. */
  types?: Array<MarketplaceZoneType> | null | undefined;
};

/** Geographic level of a marketplace search zone. */
export type MarketplaceZoneType =
  /** A city or town. */
  | 'CITY'
  /** A county or county-equivalent region. */
  | 'COUNTY'
  /** A broad neighborhood grouping. */
  | 'MACRO_NEIGHBORHOOD'
  /** A neighborhood-level area. */
  | 'NEIGHBORHOOD'
  /** A defined residential service boundary. */
  | 'RESIDENTIAL_BOUNDARY'
  /** A US state or equivalent state-level region. */
  | 'STATE'
  /** A smaller area within a neighborhood. */
  | 'SUBNEIGHBORHOOD'
  /** The geographic level could not be determined. */
  | 'UNKNOWN'
  /** A postal ZIP code area. */
  | 'ZIP_CODE';

export type MarketplaceViewportAreaNameQueryVariables = Exact<{
  input: Types.MarketplaceNearbyZonesInput;
}>;


export type MarketplaceViewportAreaNameQuery = { marketplace: { nearbyZones: Array<{ name: Types.Scalars['NonEmptyString']['output'], stateAbbr: Types.Scalars['String']['output'] | null }> } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const MarketplaceViewportAreaNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query MarketplaceViewportAreaName($input: MarketplaceNearbyZonesInput!) {
  marketplace {
    nearbyZones(input: $input) {
      name
      stateAbbr
    }
  }
}
    `) as unknown as TypedDocumentString<MarketplaceViewportAreaNameQuery, MarketplaceViewportAreaNameQueryVariables>;